import { apiClient } from './client';
import { API_CONFIG } from './config';

export type LoginRequest = { username: string; password: string };
export type LoginResponse = {
  accessToken: string;
  user: {
    userId: string;
    name: string;
    email: string;
    role: string;
    status: string;
    username: string;
    [key: string]: unknown;
  };
  project?: {
    projectId?: string;
    code?: string;
    name?: string;
    [key: string]: unknown;
  };
};

export type RegisterRequest = Record<string, unknown> & {
  name: string;
  email: string;
  password: string;
  username: string;
};
export type RegisterResponse = { message: string };

export type ProfileResponse = {
  user: LoginResponse['user'];
};

export type ChangePasswordRequest = { oldPassword: string; newPassword: string };

/** Payload of the unauthenticated set-password step behind a reset link. */
export type FirstChangePasswordRequest = { userId: string; password: string };

class AuthApi {
  private ep = API_CONFIG.endpoints.auth;

  login(data: LoginRequest) {
    return apiClient.post<LoginResponse>(this.ep.login, data);
  }

  register(data: RegisterRequest, projectId?: string) {
    return apiClient.post<RegisterResponse>(this.ep.register, data, {
      headers: projectId ? { 'project-id': projectId } : undefined,
    });
  }

  profile() {
    return apiClient.get<ProfileResponse>(this.ep.profile);
  }

  logout() {
    return apiClient.post(this.ep.logout);
  }

  changePassword(data: ChangePasswordRequest) {
    return apiClient.post(this.ep.changePassword, data);
  }

  /** Sets a password without a current one; guarded by a short-url reset link. */
  firstChangePassword(data: FirstChangePasswordRequest) {
    return apiClient.post<LoginResponse>(this.ep.firstChangePassword, data);
  }

  changeProject(projectId: string) {
    return apiClient.post<LoginResponse>(this.ep.changeProject, { projectId });
  }
}

export const authApi = new AuthApi();
